import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import type { ComponentPropsWithoutRef, ReactNode } from 'react';

const variantClass = {
    primary:
        'bg-primery-blue-700 text-white-blue-50 hover:bg-primery-blue-600 focus-visible:ring-primery-blue-700 border border-transparent',
    secondary:
        'bg-primery-blue-50 text-primery-blue-700 hover:bg-primery-blue-100 focus-visible:ring-primery-blue-200 border border-primery-blue-100',
    outline:
        'bg-white text-primery-blue-700 hover:bg-primery-blue-50 focus-visible:ring-primery-blue-200 border border-[#E8E7EA]',
    muted:
        'bg-white-blue-50 text-white-blue-800 hover:bg-primery-blue-50 focus-visible:ring-primery-blue-100 border border-[#E8E7EA]',
    danger:
        'bg-white text-red-700 hover:bg-red-50 focus-visible:ring-red-200 border border-red-200',
} as const;

type Variant = keyof typeof variantClass;

type Props = ComponentPropsWithoutRef<typeof Button> & {
    children: ReactNode;
    variant?: Variant;
    className?: string;
};

export default function SubscriptionButton({
    children,
    variant = 'primary',
    className,
    ...props
}: Props) {
    return (
        <Button
            className={cn(
                'h-auto rounded-md px-3 py-2 text-sm font-medium shadow-none transition-colors',
                'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-1',
                'disabled:pointer-events-none disabled:opacity-50',
                variantClass[variant],
                className,
            )}
            {...props}
        >
            {children}
        </Button>
    );
}
